module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("dT3EU"))).then(() => parcelRequire('7xXcy'));